const IconShareAlt = ({ size, color, ...props }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 33.46 47.91" {...props}>
        <polyline
            fill="none"
            strokeWidth="2"
            stroke={color}
            points="9.52,14.94 0.49,14.94 0.49,47.42 32.97,47.42 32.97,14.94 23.83,14.94"
        />

        <polyline fill="none" strokeWidth="2" stroke={color} points="8.53,8.86 16.73,0.65 24.94,8.86" />
        <line fill="none" strokeWidth="2" stroke={color} x1="16.73" y1="40.32" x2="16.73" y2="1.07" />
    </svg>
);

export default IconShareAlt;
